// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (max-width:639px){.sets-page__message-image{.sets-message-image{.sets-message-image__left-tags{position:relative;top:10px;&>div{& .tag__root{& .tag__text{font-size:14px;color:#1571a6!important;padding-bottom:8px}}}}}}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
